import React, { useState, useEffect, useCallback } from 'react';
import SecureFileImg from '../SecureFileImg';
import { openInAppFilePreview } from '../../utils/filePreviewBus';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { labelValidasi } from '../../utils/labelValidasi';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, Card, CardContent, Chip, TextField, InputAdornment,
  Tooltip, CircularProgress, Alert, Snackbar, Fade, Container, Button,
  Select, MenuItem, FormControl, InputLabel, IconButton, Dialog, DialogTitle,
  DialogContent, Divider, LinearProgress, Stack, useMediaQuery,
  Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  Search, Refresh, Visibility, NavigateBefore, NavigateNext,
  HomeWork, AssignmentTurnedIn, Payments, SourceOutlined,
  ExpandMore, Check, Receipt, Engineering, CheckCircle,
  Add, Edit, Delete, PersonAdd, CalendarMonth
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import {
  getBantuan, getBantuanById, getPresentase, getBantuanYears,
  createBantuanLengkap, createBantuanManual, updateBantuan, deleteBantuan,
  getBantuanGaps, syncBantuanGaps, getTflList, getAgrList, assignTflToBantuan, updatePenerimaByTfl,
  getRabByBantuan, getProgressKeuangan, getProgressFisik, getProgressAdministrasi
} from '../API/bantuan';
import { getSupplierBarang } from '../API/supplierPenyedia';
import SourceDropdown from './modalAdd/SourceDropdown';
import ManualBantuanFields from './modalAdd/ManualBantuanFields';
import { FilePreviewModal, FileThumbnail } from './FilePreview';
import "./DataBantuan.css"

import { formatNominalInput, parseNominalInput } from '../../utils/currency';
import { getDocumentLabels } from '../../utils/stepTemplates';
import { KECAMATAN, getDesaByKecamatan } from '../datarecap/constants';

// Mapping display ↔ backend ENUM
// Backend menyimpan "Rehab Rumah Tidak Layak Huni", ditampilkan sebagai "Rehabilitasi Rumah Tidak Layak Huni"
const JENIS_DISPLAY = [
  'Pembangunan Rumah Layak Huni', 'Rehabilitasi Rumah Tidak Layak Huni'
];
const DISPLAY_TO_BACKEND = {
  'Pembangunan Rumah Layak Huni': 'Pembangunan Rumah Layak Huni',
  'Rehabilitasi Rumah Tidak Layak Huni': 'Rehab Rumah Tidak Layak Huni',
};
const BACKEND_TO_DISPLAY = {
  'Pembangunan Rumah Layak Huni': 'Pembangunan Rumah Layak Huni',
  'Rehab Rumah Tidak Layak Huni': 'Rehabilitasi Rumah Tidak Layak Huni',
};
const toDisplayJenis = (v) => BACKEND_TO_DISPLAY[v] || v || '-';
const toBackendJenis = (v) => DISPLAY_TO_BACKEND[v] || v || '';
const STATUS_PROSES = ['Usulan Diterima', 'Dalam Proses', 'Selesai'];

const statusColor = (status) => {
  switch (status) {
    case 'Selesai': return 'success';
    case 'Dalam Proses': return 'warning';
    case 'Usulan Diterima': return 'info';
    default: return 'default';
  }
};

const formatRp = (n) => {
  if (n === null || n === undefined || isNaN(Number(n))) return '-';
  return 'Rp ' + Number(n).toLocaleString('id-ID');
};

const buildMetadataFromSource = (source, sumberType) => {
  if (!source?.id) return { desil: '', kode: '', HasilVerfak: '' };
  const year = new Date().getFullYear();
  const prefix = sumberType === 'Questionnaire' ? 'Q' : sumberType === 'Verifikasi' ? 'V' : 'R';
  return {
    desil: source.score != null && source.score !== '' ? String(source.score) : '',
    kode: `${source.kecamatan || ''}·${source.desaKelurahan || ''}·${prefix}${source.id}|${year}`,
    HasilVerfak: source.kategori || source.statusVerifikasi || source.status || ''
  };
};

const DetailRow = ({ label, value }) => (
  <div className="col-md-6 mb-2">
    <small className="text-muted d-block">{label}</small>
    <strong>{value || '-'}</strong>
  </div>
);

const styles = {
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    flexWrap: 'wrap', mb: 2
  },
  searchBar: {
    display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap', mb: 2
  },
  cardHeader: {
    borderBottom: '1px solid rgba(0,0,0,0.12)', py: 1.5, px: 2,
    backgroundColor: '#f9fafc', display: 'flex', alignItems: 'center', gap: 1
  },
  paginationContainer: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    p: 2, borderTop: '1px solid rgba(0,0,0,0.12)', flexWrap: 'wrap', gap: 1
  },
  emptyState: { textAlign: 'center', py: 6, color: 'text.secondary' }
};

const langkahStatusColor = (status) => {
  switch (status) {
    case 'Selesai': return 'success';
    case 'Sedang Berlangsung': return 'warning';
    case 'Menunggu Verifikasi': return 'info';
    default: return 'default';
  }
};

const TimelineList = ({ items, basePath, isSingleFoto, onPreview, type = 'administrasi' }) => {
  const BASE = process.env.REACT_APP_URL;
  return (
    <Box sx={{ position: 'relative', pl: 2 }}>
      {items.map((step, index) => (
        <Box key={step.id} sx={{ position: 'relative', pb: 2.5 }}>
          {index < items.length - 1 && (
            <Box sx={{ position: 'absolute', left: -5, top: 24, bottom: 0, width: 2, bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0' }} />
          )}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <Box sx={{
              minWidth: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              bgcolor: step.status === 'Selesai' ? 'success.main' : step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
              color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white', fontSize: 12, fontWeight: 600, zIndex: 1,
            }}>
              {step.status === 'Selesai' ? <Check fontSize="inherit" /> : index + 1}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <Typography variant="body2" fontWeight={500}>{labelValidasi(step.tahap)}</Typography>
                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                  <Chip size="small" label={`${step.bobot}%`} variant="outlined" sx={{ fontSize: 11 }} />
                  <Chip size="small" color={langkahStatusColor(step.status)} label={labelValidasi(step.status)} />
                </Box>
              </Box>
              {step.foto && !isSingleFoto && (() => {
                try {
                  const fotos = JSON.parse(step.foto);
                  if (Array.isArray(fotos) && fotos.length > 0) {
                    return (
                      <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                        {fotos.map((f, fi) => (
                          <FileThumbnail key={fi} file={f} label={`Foto ${fi + 1}`} fileBase={basePath}
                            onPreview={() => onPreview?.(fotos, fotos.map((_, i) => `Foto ${i + 1}`), basePath, step.tahap)} />
                        ))}
                      </Stack>
                    );
                  }
                } catch (e) {}
                return null;
              })()}
              {step.foto && isSingleFoto && (
                <Box sx={{ mt: 0.5 }}>
                  <FileThumbnail file={step.foto} label="Foto" fileBase={basePath}
                    onPreview={() => onPreview?.(step.foto, 'Foto', basePath, step.tahap)} />
                </Box>
              )}
              {step.dokumen && (() => {
                try {
                  const docs = JSON.parse(step.dokumen);
                  if (Array.isArray(docs) && docs.length > 0) {
                    const labels = getDocumentLabels(type, step, docs);
                    return (
                      <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                        {docs.map((d, di) => (
                          <FileThumbnail key={di} file={d} label={labels[di]} fileBase={basePath}
                            onPreview={() => onPreview?.(docs, labels, basePath, step.tahap)} />
                        ))}
                      </Stack>
                    );
                  }
                } catch (e) {}
                return null;
              })()}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

const DataBantuan = () => {
  const navigate = useNavigate();
  const userRole = useSelector((s) => s.authAdmin?.user?.role);
  const userId = useSelector((s) => s.authAdmin?.user?.id);
  const isAdmin = userRole === 'admin';
  const isTfl = userRole === 'TFL';

  // =============== PERBAIKAN: TFL dan Admin bisa akses CRUD ===============
  const canAccessCRUD = isAdmin || isTfl;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [searchName, setSearchName] = useState('');
  const [kecamatan, setKecamatan] = useState('');
  const [desaKelurahan, setDesaKelurahan] = useState('');
  const [kategori, setKategori] = useState('');
  const [statusProses, setStatusProses] = useState('');
  const [jenisBantuan, setJenisBantuan] = useState('');
  const [tahun, setTahun] = useState('');
  const [tahunList, setTahunList] = useState([]);

  const [detailOpen, setDetailOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [presentase, setPresentase] = useState(null);
  const [rabData, setRabData] = useState(null);
  const [progressKeuangan, setProgressKeuangan] = useState([]);
  const [progressFisik, setProgressFisik] = useState([]);
  const [progressAdministrasi, setProgressAdministrasi] = useState([]);

  // CRUD modal state
  const [formOpen, setFormOpen] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [formTab, setFormTab] = useState('integrasi');
  const [saving, setSaving] = useState(false);
  const [tflList, setTflList] = useState([]);
  const [agrList, setAgrList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [assignOpen, setAssignOpen] = useState(false);
  const [assignRow, setAssignRow] = useState(null);
  const [assignForm, setAssignForm] = useState({ AdminId: '', AgrId: '', supplierId: '', supplierIds: [] });
  const [penerimaForm, setPenerimaForm] = useState({ noWaPenerimaBantuan: '', noRekening: '' });
  const [form, setForm] = useState({
    id: null, JenisBantuan: 'Pembangunan Rumah Layak Huni', nominal: 50000000,
    nominalMaterial: 0, nominalUpahKerja: 0,
    tanggalBantuan: new Date().toISOString().slice(0, 10), sumberType: '',
    QuestionnaireId: '', RegisterUsulanId: '', VerifikasiId: '',
    selQuestionnaire: null, selRegisterUsulan: null, selVerifikasi: null,
    desil: '', kode: '', HasilVerfak: '', sumberPreview: null,
    AdminId: '', AgrId: '', supplierId: '', supplierIds: [],
    agrFilterKecamatan: '', agrFilterDesa: '',
    noWaPenerimaBantuan: '', noRekening: '',
    statusKontrak: 'Sudah SK', nomorSK: '', tanggalSK: '',
  });

  // Gap state
  const [gapOpen, setGapOpen] = useState(false);
  const [gapData, setGapData] = useState(null);
  const [gapLoading, setGapLoading] = useState(false);

  const [preview, setPreview] = useState({ open: false, files: [], labels: [], fileBase: null, title: '' });

  const openPreview = (files, labels, fileBase, title) => {
    setPreview({ open: true, files: Array.isArray(files) ? files : [files], labels: Array.isArray(labels) ? labels : [labels], fileBase: fileBase || null, title: title || 'Preview' });
  };

  const isMobile = useMediaQuery('(max-width:800px)');

  // Opsi desa/kelurahan unik dari data bantuan (sumber DB), dipakai saat filter "Semua Kecamatan"
  const allDesaOptions = [...new Set(
    rows
      .map((r) => r.pemohon?.desaKelurahan || r.desaKelurahan || '')
      .filter(Boolean)
  )].sort((a, b) => a.localeCompare(b, 'id'));

  // AGR difilter berdasarkan kecamatan & desa/kelurahan wilayah AGR
  const filteredAgrList = agrList.filter((a) => {
    if (form.agrFilterKecamatan && a.kecamatan !== form.agrFilterKecamatan) return false;
    if (form.agrFilterDesa && a.desaKelurahan !== form.agrFilterDesa) return false;
    return true;
  });

  // =============== Load TFL/AGR/Supplier untuk semua user yang bisa akses ===============
  useEffect(() => {
    getBantuanYears().then(r => setTahunList(r.data?.data || [])).catch(() => {});
    if (!canAccessCRUD) return;
    (async () => {
      try {
        const [tflRes, agrRes, supRes] = await Promise.all([
          getTflList(),
          getAgrList(),
          getSupplierBarang({ limit: 200 }),
        ]);
        setTflList(tflRes.data?.data || []);
        setAgrList(agrRes.data?.data || agrRes.data || []);
        setSupplierList(supRes.data?.data || supRes.data || []);
      } catch (e) {
        console.error('Load TFL/AGR/supplier list:', e);
      }
    })();
  }, [canAccessCRUD]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getBantuan({
        page, limit, searchName, kecamatan, desaKelurahan,
        kategori, statusProses, JenisBantuan: toBackendJenis(jenisBantuan), tahun
      });
      setRows(res.data.data || []);
      setTotalItems(res.data.pagination.totalItems);
      setTotalPages(res.data.pagination.totalPages);
    } catch (err) {
      console.error('Error getBantuan:', err);
      setError('Gagal mengambil data penerima bantuan');
      setSnackbar({ open: true, message: 'Gagal mengambil data penerima bantuan', severity: 'error' });
    } finally {
      setLoading(false);
    }
  }, [page, limit, searchName, kecamatan, desaKelurahan, kategori, statusProses, jenisBantuan, tahun]);

  useEffect(() => {
    const t = setTimeout(() => fetchData(), 400);
    return () => clearTimeout(t);
  }, [fetchData]);

  const handleReset = () => {
    setSearchName(''); setKecamatan(''); setDesaKelurahan('');
    setKategori(''); setStatusProses(''); setJenisBantuan(''); setTahun(''); setPage(1);
  };

  const openDetail = async (id) => {
    setDetailOpen(true);
    setDetailLoading(true);
    setDetail(null);
    setPresentase(null);
    setRabData(null);
    setProgressKeuangan([]);
    setProgressFisik([]);
    setProgressAdministrasi([]);
    try {
      const [res, pres] = await Promise.all([
        getBantuanById(id),
        getPresentase(id).catch(() => null)
      ]);
      setDetail(res.data.data);
      setPenerimaForm({
        noWaPenerimaBantuan: res.data.data?.noWaPenerimaBantuan || '',
        noRekening: res.data.data?.noRekening || '',
      });
      if (pres?.data) setPresentase(pres.data.presentase);

      try {
        const rabRes = await getRabByBantuan(id);
        const rab = rabRes.data?.data;
        if (rab) {
          setRabData(rab);
          const [pkRes, pfRes, paRes] = await Promise.allSettled([
            getProgressKeuangan(rab.id).catch(() => ({ data: { data: [] } })),
            getProgressFisik(rab.id).catch(() => ({ data: { data: [] } })),
            getProgressAdministrasi(rab.id).catch(() => ({ data: { data: [] } })),
          ]);
          setProgressKeuangan(pkRes.value?.data?.data || []);
          setProgressFisik(pfRes.value?.data?.data || []);
          setProgressAdministrasi(paRes.value?.data?.data || []);
        }
      } catch (e) { console.error('Fetch RAB/progress:', e); }
    } catch (err) {
      console.error('Error detail:', err);
      setSnackbar({ open: true, message: 'Gagal mengambil detail bantuan', severity: 'error' });
    } finally {
      setDetailLoading(false);
    }
  };

  const handleRefresh = () => {
    Swal.fire({
      title: 'Muat ulang data?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, muat ulang',
      cancelButtonText: 'Batal'
    }).then((r) => { if (r.isConfirmed) fetchData(); });
  };

  const applySourceSelection = (sumberType, source) => {
    const meta = buildMetadataFromSource(source, sumberType);
    setForm((p) => ({
      ...p,
      sumberType,
      sumberPreview: source,
      desil: meta.desil,
      kode: meta.kode,
      HasilVerfak: meta.HasilVerfak
    }));
  };

  // =============== CRUD BANTUAN ===============
  const openAdd = () => {
    navigate('/data-bantuan/tambah');
  };

 const openEdit = (row) => {
  const sumberType = row.QuestionnaireId ? 'Questionnaire' : row.VerifikasiId ? 'Verifikasi' : row.RegisterUsulanId ? 'RegisterUsulan' : '';
  const nama = row.pemohon?.nama || '';
  const kec = row.pemohon?.kecamatan || '';
  const placeholder = (id) => id ? { id, label: `${id} - ${nama} (${kec})` } : null;
  
  setFormMode('edit');
  setForm({
    id: row.id,
    JenisBantuan: row.JenisBantuan || 'Pembangunan',
    nominal: row.nominal || 0,
    nominalMaterial: row.nominalMaterial || 0,
    nominalUpahKerja: row.nominalUpahKerja || row.upahKerja || 0,
    tanggalBantuan: row.tanggalBantuan || '',
    sumberType,
    QuestionnaireId: row.QuestionnaireId || '',
    RegisterUsulanId: row.RegisterUsulanId || '',
    VerifikasiId: row.VerifikasiId || '',
    selQuestionnaire: placeholder(row.QuestionnaireId),
    selRegisterUsulan: placeholder(row.RegisterUsulanId),
    selVerifikasi: placeholder(row.VerifikasiId),
    desil: row.desil || '',
    kode: row.kode || '',
    HasilVerfak: row.HasilVerfak || '',
    sumberPreview: row.pemohonDetail || row.pemohon || null,
    AdminId: row.AdminId || '',
    AgrId: row.AgrId || '',
    supplierId: row.supplierId || '',
    // Supplier yang sudah terpilih: list memakai `SupplierBarang`, detail memakai `dataSupplier`
    supplierIds: (row.SupplierBarang || row.dataSupplier || []).map(s => s.id),
    agrFilterKecamatan: '', agrFilterDesa: '',
    statusKontrak: row.statusKontrak || 'Sudah SK',
    nomorSK: row.nomorSK || '',
    tanggalSK: row.tanggalSK || '',
    tanggalSelesai: row.tanggalSelesai || '',
    noWaPenerimaBantuan: row.noWaPenerimaBantuan || '',
    noRekening: row.noRekening || '',
  });
  setPenerimaForm({
    noWaPenerimaBantuan: row.noWaPenerimaBantuan || '',
    noRekening: row.noRekening || '',
  });
  setFormOpen(true);
};

  const handleSave = async () => {
    if (!form.JenisBantuan) return setSnackbar({ open: true, message: 'Jenis bantuan wajib diisi', severity: 'warning' });

    if (formMode === 'add' && formTab === 'manual') {
      if (!form.namaLengkap) {
        return setSnackbar({ open: true, message: 'Nama lengkap wajib diisi', severity: 'warning' });
      }
      setSaving(true);
      try {
        await createBantuanManual({
          namaLengkap: form.namaLengkap,
          nomorKK: form.nomorKK,
          nomorKTP: form.nomorKTP,
          alamatLengkap: form.alamatLengkap,
          kecamatan: form.kecamatan,
          desaKelurahan: form.desaKelurahan,
          koordinat: form.koordinat,
          JenisBantuan: form.JenisBantuan,
          AdminId: form.AdminId || null, AgrId: form.AgrId || null,
       supplierId: form.supplierId || null,
       SupplierBarangIds: form.supplierIds || [],
          SupplierBarangIds: form.supplierIds || [],
          statusKontrak: form.statusKontrak,
          nomorSK: form.nomorSK,
          tanggalSK: form.tanggalSK || null,
          tanggalBantuan: form.tanggalBantuan,
            noWaPenerimaBantuan: form.noWaPenerimaBantuan || '',
        noRekening: form.noRekening || '',
        });
        setSnackbar({ open: true, message: 'Bantuan SK manual berhasil ditambahkan', severity: 'success' });
        setFormOpen(false);
        fetchData();
      } catch (err) {
        setSnackbar({ open: true, message: err.response?.data?.msg || 'Gagal menyimpan bantuan manual', severity: 'error' });
      } finally {
        setSaving(false);
      }
      return;
    }

const payload = {
       JenisBantuan: form.JenisBantuan,
       nominal: Number(form.nominal) || 0,
       nominalMaterial: Number(form.nominalMaterial) || 0,
       upahKerja: Number(form.nominalUpahKerja) || 0,
       tanggalBantuan: form.tanggalBantuan || null,
       desil: form.desil || '',
       kode: form.kode || '',
       HasilVerfak: form.HasilVerfak || '',
       AdminId: form.AdminId || null,
       AgrId: form.AgrId || null,
       supplierId: form.supplierId || null,
       SupplierBarangIds: form.supplierIds || [],
       noWaPenerimaBantuan: form.noWaPenerimaBantuan || '',
       noRekening: form.noRekening || ''
     };
    // Sumber: hanya set saat add (edit tidak ubah sumber agar RegisterUsulanId tidak hilang)
    if (formMode === 'add') {
      if (form.sumberType === 'Questionnaire') {
        payload.QuestionnaireId = form.selQuestionnaire?.id || null;
        payload.VerifikasiId = null;
        payload.RegisterUsulanId = form.RegisterUsulanId || null;
      } else if (form.sumberType === 'Verifikasi') {
        payload.VerifikasiId = form.selVerifikasi?.id || null;
        payload.QuestionnaireId = null;
        payload.RegisterUsulanId = form.RegisterUsulanId || null;
      } else if (form.sumberType === 'RegisterUsulan') {
        payload.RegisterUsulanId = form.selRegisterUsulan?.id || null;
        payload.QuestionnaireId = null;
        payload.VerifikasiId = null;
      } else {
        payload.QuestionnaireId = null;
        payload.RegisterUsulanId = null;
        payload.VerifikasiId = null;
      }
    }

    setSaving(true);
    try {
      if (formMode === 'add') {
        await createBantuanLengkap(payload);
        setSnackbar({ open: true, message: 'Bantuan berhasil ditambahkan', severity: 'success' });
      } else {
        await updateBantuan(form.id, payload);
        setSnackbar({ open: true, message: 'Bantuan berhasil diupdate', severity: 'success' });
      }
      setFormOpen(false);
      fetchData();
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: err.response?.data?.msg || err.response?.data?.message || 'Gagal menyimpan bantuan', severity: 'error' });
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = (row) => {
    Swal.fire({
      title: 'Hapus bantuan ini?',
      text: `${row.pemohon?.nama || ''} - ${toDisplayJenis(row.JenisBantuan)}`,
      icon: 'warning', showCancelButton: true,
      confirmButtonColor: '#d33', confirmButtonText: 'Hapus', cancelButtonText: 'Batal'
    }).then(async (r) => {
      if (!r.isConfirmed) return;
      try {
        await deleteBantuan(row.id);
        setSnackbar({ open: true, message: 'Bantuan dihapus', severity: 'success' });
        fetchData();
      } catch (err) {
        setSnackbar({ open: true, message: 'Gagal menghapus bantuan', severity: 'error' });
      }
    });
  };

  const openAssign = (row) => {
    setAssignRow(row);
    setAssignForm({
      AdminId: row.AdminId || (isTfl ? String(userId || '') : ''),
      AgrId: row.AgrId || '',
      supplierId: row.supplierId || '',
      supplierIds: row.dataSupplier?.map(s => s.id) || [],
    });
    setAssignOpen(true);
  };

  const handleAssignTfl = async () => {
    if (!assignRow?.id) {
      return setSnackbar({ open: true, message: 'Data penerima bantuan tidak valid', severity: 'warning' });
    }
    try {
      await assignTflToBantuan(assignRow.id, assignForm);
      setSnackbar({ open: true, message: 'Penunjukan TFL/AGR berhasil', severity: 'success' });
      setAssignOpen(false);
      fetchData();
    } catch (err) {
      setSnackbar({ open: true, message: err.response?.data?.message || 'Gagal menunjuk TFL/AGR', severity: 'error' });
    }
  };

  const handleSavePenerima = async () => {
    if (!detail?.id) return;
    try {
      await updatePenerimaByTfl(detail.id, penerimaForm);
      setSnackbar({ open: true, message: 'Data penerima diperbarui', severity: 'success' });
      openDetail(detail.id);
    } catch (err) {
      setSnackbar({ open: true, message: err.response?.data?.message || 'Gagal menyimpan', severity: 'error' });
    }
  };

  // =============== GAP DETECTION ===============
  const openGaps = async () => {
    setGapOpen(true); setGapLoading(true); setGapData(null);
    try {
      const res = await getBantuanGaps();
      setGapData(res.data);
    } catch (err) {
      setSnackbar({ open: true, message: 'Gagal memuat gap', severity: 'error' });
    } finally {
      setGapLoading(false);
    }
  };

  const handleSyncGaps = () => {
    Swal.fire({
      title: 'Sinkronisasi semua gap?',
      text: 'Bantuan akan dibuat otomatis untuk data terverifikasi yang belum punya bantuan.',
      icon: 'question', showCancelButton: true,
      confirmButtonText: 'Ya, sinkronkan', cancelButtonText: 'Batal'
    }).then(async (r) => {
      if (!r.isConfirmed) return;
      try {
        const res = await syncBantuanGaps({});
        setSnackbar({ open: true, message: res.data.message, severity: 'success' });
        openGaps();
        fetchData();
      } catch (err) {
        setSnackbar({ open: true, message: 'Gagal sinkronisasi', severity: 'error' });
      }
    });
  };

  const pemohon = detail?.pemohonDetail || detail?.pemohon;

  const contentStyle = isMobile 
    ? {} 
    : { marginLeft: "250px", marginRight: "20px" };

  return (
    <div className="table-responsive rounded border">
      <div className="main-content" style={contentStyle}>
        <Row className="mb-3 align-items-center">
          <Col>
            <h4>Data Penerima Bantuan</h4>
          </Col>
          <Row className="mb-3 align-items-center">
          <Col className="text-end">
            {/* =============== PERBAIKAN: Deteksi Gap hanya Admin =============== */}
          
            </Col>
              <Col className="text-end">
            {/* =============== PERBAIKAN: Button Tambah untuk Admin & TFL =============== */}
            {canAccessCRUD && (
              <Button color="success" size="sm" className="me-2" onClick={openAdd}>
                <Add fontSize="small" /> Tambah Data
              </Button>
            )}
            </Col>
            <Col className="text-end">
            <Button color="primary" size="sm" onClick={handleRefresh}>
              <Refresh /> Muat Ulang
            </Button>
            
          </Col>
          </Row>
        </Row>

        {/* Search Bar */}
        <Row className="mb-3">
          <Col>
            <Row className="g-2">
              <Col xs={12} md={3}>
                <Input
                  type="text"
                  placeholder="Cari nama Penerima..."
                  value={searchName}
                  onChange={(e) => { setSearchName(e.target.value); setPage(1); }}
                />
              </Col>
              <Col xs={6} md={2}>
                <Input
                  type="select"
                  value={kecamatan}
                  onChange={(e) => { setKecamatan(e.target.value); setDesaKelurahan(''); setPage(1); }}
                >
                  <option value="">Semua Kecamatan</option>
                  {KECAMATAN.map((k) => (
                    <option key={k} value={k}>{k}</option>
                  ))}
                </Input>
              </Col>
              <Col xs={6} md={2}>
                <Input
                  type="select"
                  value={desaKelurahan}
                  onChange={(e) => { setDesaKelurahan(e.target.value); setPage(1); }}
                >
                  <option value="">Semua Desa/Kelurahan</option>
                  {(kecamatan ? getDesaByKecamatan(kecamatan) : allDesaOptions).map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </Input>
              </Col>
              <Col xs={6} md={2}>
                <Input
                  type="select"
                  value={statusProses}
                  onChange={(e) => { setStatusProses(e.target.value); setPage(1); }}
                >
                  <option value="">Status Proses</option>
                  {STATUS_PROSES.map((s) => <option key={s} value={s}>{s}</option>)}
                </Input>
              </Col>
              <Col xs={6} md={2}>
                <Input
                  type="select"
                  value={jenisBantuan}
                  onChange={(e) => { setJenisBantuan(e.target.value); setPage(1); }}
                >
                  <option value="">Semua</option>
                  {JENIS_DISPLAY.map((j) => <option key={j} value={j}>{j}</option>)}
                </Input>
              </Col>
              <Col xs={6} md={2}>
                <Input
                  type="select"
                  value={tahun}
                  onChange={(e) => { setTahun(e.target.value); setPage(1); }}
                >
                  <option value="">Semua Tahun</option>
                  {tahunList.map((y) => <option key={y} value={y}>{y}</option>)}
                </Input>
              </Col>
              <Col xs={12} md={1}>
                <Button color="secondary" size="sm" onClick={handleReset} block>
                  Reset
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        {error && (
          <Row className="mb-3">
            <Col>
              <Alert color="danger">{error}</Alert>
            </Col>
          </Row>
        )}

        {/* Table */}
        <Row>
          <Col>
            <div className="table-responsive rounded border">
              <Table hover responsive className="mb-0">
                <thead className="table-light table-header">
                  <tr>
                    <th>No.</th>
                    <th>Nama Penerima</th>
                    <th>Sumber</th>
                    <th>Kecamatan</th>
                    <th>Desa/Kelurahan</th>
                    <th>Alamat</th>
                    <th>Jenis Bantuan</th>
                    <th>Nominal</th>
                    <th>TFL</th>
                    <th>Status Proses</th>
                    <th className="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={11} className="text-center py-4">
                        <CircularProgress size={28} />
                      </td>
                    </tr>
                  ) : rows.length === 0 ? (
                    <tr>
                      <td colSpan={11} className="text-center py-4">
                        {tahun ? `Tidak ada data penerima bantuan pada tahun ${tahun}.` : 'Tidak ada data penerima bantuan ditemukan.'}
                      </td>
                    </tr>
                  ) : rows.map((row, i) => (
                    <tr key={row.id}>
                      <td>{(page - 1) * limit + i + 1}</td>
                      <td>
                        <strong>{row.pemohon?.nama || '-'}</strong>
                        <br />
                        <small className="text-muted">{row.pemohon?.nik || row.pemohon?.nomorKTP || ''}</small>
                      </td>
                      <td>
                        <span className="badge bg-secondary">{row.pemohon?.sumber || '-'}</span>
                      </td>
                      <td>{row.pemohon?.kecamatan || '-'}</td>
                      <td>{row.pemohon?.desaKelurahan || '-'}</td>
                      <td>{row.pemohon?.alamat || '-'}</td>
                      <td>{toDisplayJenis(row.JenisBantuan)}</td>
                      <td>{formatRp(row.nominal)}</td>
                      <td>{row.namaTFL || row.TFL?.username || '-'}</td>
                      <td>
                        <span className={`badge bg-${statusColor(row.ProsesBantuan?.statusProses)}`}>
                          {row.ProsesBantuan?.statusProses || '-'}
                        </span>
                      </td>
                      <td className="text-center">
                        <Button
                          color="primary"
                          size="sm"
                          className="me-1"
                          onClick={() => navigate(`/data-bantuan/${row.id}`)}
                        >
                          <Visibility fontSize="small" /> Detail
                        </Button>
                        
                        {/* =============== PERBAIKAN: TFL & Admin bisa akses Edit/Hapus/TFL =============== */}
                        {canAccessCRUD && (
                          <>
                            {/* <Button color="info" size="sm" className="me-1" onClick={() => openAssign(row)}>
                              <PersonAdd fontSize="small" /> TFL
                            </Button> */}
                            <Button color="warning" size="sm" className="me-1" onClick={() => openEdit(row)}>
                              <Edit fontSize="small" /> Edit
                            </Button>
                            <Button color="danger" size="sm" onClick={() => handleDelete(row)}>
                              <Delete fontSize="small" /> Hapus
                            </Button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>

        {/* Pagination */}
        <Row className="align-items-center mt-3">
            <Col md="6" className="mb-2 mb-md-0">
              <div className="d-flex align-items-center gap-2">
                <span>Tampilkan:</span>
                <Input 
                  type="select" 
                  value={limit} 
                  onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }} 
                  style={{ width: 100 }}
                >
                  <option value={10}>10 data</option>
                  <option value={25}>25 data</option>
                  <option value={50}>50 data</option>
                  <option value={100}>100 data</option>
                </Input>
                <span className="text-muted">Hal. {page} / {totalPages} ({totalItems} data)</span>
              </div>
            </Col>
            {totalPages > 1 && (
            <Col md="6">
              <div className="d-flex justify-content-md-end gap-2">
                <Button 
                  size="sm" 
                  disabled={page <= 1} 
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                >
                  <NavigateBefore /> Prev
                </Button>
                <Button 
                  size="sm" 
                  disabled={page >= totalPages} 
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                >
                  Next <NavigateNext />
                </Button>
              </div>
            </Col>
            )}
          </Row>
      

        {/* Modal Detail */}
        <Modal
          isOpen={detailOpen}
          toggle={() => setDetailOpen(false)}
          size="xl"
          style={{ maxWidth: isMobile ? '100%' : '1000px', width: isMobile ? '100%' : 'auto', margin: isMobile ? '0' : undefined, zIndex: 1800 }}
          backdropStyle={{ zIndex: 1999 }}
        >
          <ModalHeader toggle={() => setDetailOpen(false)} style={{ padding: isMobile ? '0.75rem' : undefined }}>
            <AssignmentTurnedIn /> Detail Bantuan
          </ModalHeader>
          <ModalBody style={{ padding: isMobile ? '0.75rem' : undefined }}>
            {detailLoading ? (
              <div className="text-center py-5">
                <CircularProgress />
              </div>
            ) : detail ? (
              <div>
                <h6 className="text-muted">Penerima</h6>
                <h5>{pemohon?.nama || '-'}</h5>
                <p>{pemohon?.alamat || '-'}</p>
                <div className="d-flex flex-wrap gap-1 mb-3">
                  <span className="badge bg-info">Kec. {pemohon?.kecamatan || '-'}</span>
                  <span className="badge bg-info">Desa {pemohon?.desaKelurahan || '-'}</span>
                  {pemohon?.kategori && <span className="badge bg-primary">{pemohon.kategori}</span>}
                  {pemohon?.score != null && <span className="badge bg-secondary">Skor: {pemohon.score}</span>}
                  <span className="badge bg-secondary">Sumber: {pemohon?.sumber || '-'}</span>
                </div>

                <div className="row">
                  <DetailRow label="NIK" value={pemohon?.nik || pemohon?.nomorKTP} />
                  <DetailRow label="Nomor KK" value={pemohon?.nomorKK} />
                  <DetailRow label="Status Rumah" value={pemohon?.statusrumah} />
                  <DetailRow label="Status Validasi" value={pemohon?.statusVerifikasi || pemohon?.verifikasiBantuan} />
                  <DetailRow label="Pekerjaan" value={pemohon?.pekerjaan} />
                  <DetailRow label="Tanggal Pendataan" value={pemohon?.tanggalPendataan} />
                </div>

                {detail.Questionnaire?.fotos && detail.Questionnaire.fotos.length > 0 && (
                  <div className="mt-2 mb-2">
                    <small className="text-muted d-block mb-1">Foto Rumah Penerima</small>
                    <div className="d-flex gap-1 flex-wrap">
                      {detail.Questionnaire.fotos.slice(0, 5).map((f, fi) => (
                        <img key={fi} src={`${process.env.REACT_APP_URL}/${f.foto_rumah}`} alt={`Foto ${fi+1}`}
                          style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd', cursor: 'pointer' }}
                          onClick={() => openInAppFilePreview({ url: `${process.env.REACT_APP_URL}/${f.foto_rumah}` })} />
                      ))}
                    </div>
                  </div>
                )}

                <hr />
                <div className="row">
                  <div className="col-md-6">
                    <h6 className="text-muted">Jenis & Nominal</h6>
                    <p><strong>{toDisplayJenis(detail.JenisBantuan)}</strong></p>
                    <p className="text-primary fw-bold">{formatRp(detail.nominal)}</p>
                    <p><small className="text-muted">Tanggal: {detail.tanggalBantuan || '-'}</small></p>
                  </div>
                  <div className="col-md-6">
                    <h6 className="text-muted">Status Proses</h6>
                    <span className={`badge bg-${statusColor(detail.ProsesBantuan?.statusProses)}`}>
                      {detail.ProsesBantuan?.statusProses || '-'}
                    </span>
                  </div>
                </div>

                <hr />
                <div className="row">
                  {/* <DetailRow label="Desil" value={detail.desil} />
                  <DetailRow label="Kode" value={detail.kode} />
                  <DetailRow label="Hasil Verfak" value={detail.HasilVerfak} /> */}
                  <DetailRow label="TFL" value={detail.namaTFL || detail.TFL?.username} />
                  <DetailRow label="AGR" value={detail.namaAgr || detail.AGR?.username} />
                  <DetailRow label="Supplier" value={detail.dataSupplier?.[0]?.namaSupplier || "-"} />
                  <DetailRow label="Tanggal Selesai" value={detail.tanggalSelesai} />
                  <DetailRow label="No. WA Penerima" value={detail.noWaPenerimaBantuan} />
                  <DetailRow label="No. Rekening" value={detail.noRekening} />
                </div>

                {(detail.latitude && detail.longitude) && (
                  <>
                    <hr />
                    <h6 className="text-muted">Lokasi (Peta)</h6>
                    <a
                      href={`https://www.google.com/maps?q=${detail.latitude},${detail.longitude}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Buka di Google Maps ({detail.latitude}, {detail.longitude})
                    </a>
                  </>
                )}

                {(isTfl || isAdmin) && detail.id && (
                  <>
                    <hr />
                    <h6 className="text-muted">Data Penerima</h6>
                  <Row className="g-2 mb-2">
  <Col md={6}>
    <FormGroup>
      <Label className="fw-semibold">No. WA Penerima</Label>
      <Input
        placeholder="Contoh: 081234567890"
        value={form.noWaPenerimaBantuan || ''}
        onChange={(e) => setForm((p) => ({ ...p, noWaPenerimaBantuan: e.target.value }))}
        disabled={!isTfl && !isAdmin}
      />
    </FormGroup>
  </Col>
  <Col md={6}>
    <FormGroup>
      <Label className="fw-semibold">No. Rekening</Label>
      <Input
        placeholder="Contoh: 1234567890"
        value={form.noRekening || ''}
        onChange={(e) => setForm((p) => ({ ...p, noRekening: e.target.value }))}
        disabled={!isTfl && !isAdmin}
      />
    </FormGroup>
  </Col>
</Row>
                    <Button color="primary" size="sm" onClick={handleSavePenerima}>
                      Simpan Data Penerima
                    </Button>
                  </>
                )}

                {(isTfl || isAdmin) && detail.id && presentase?.presentase >= 100 && (
                  <>
                    <hr />
                    <Alert severity="success">
                      Progress 100% — status rumah penerima bantuan diperbarui menjadi Layak Huni.
                      Nominal: {formatRp(detail.nominal)} · Selesai: {detail.tanggalSelesai || '-'}
                    </Alert>
                  </>
                )}

                <hr />
                <div>
                  <h6 className="text-muted">Progress Pengerjaan</h6>
                  {presentase ? (
                    <div>
                      <div className="d-flex justify-content-between">
                        <span>{presentase.langkahSelesai}/{presentase.totalLangkah} langkah selesai</span>
                        <span className="fw-bold text-primary">{presentase.presentase}%</span>
                      </div>
                      <div className="progress" style={{ height: '10px' }}>
                        <div
                          className="progress-bar"
                          style={{ width: `${presentase.presentase}%` }}
                        />
                      </div>
                    </div>
                  ) : (
                    <p className="text-muted">Data presentase belum tersedia.</p>
                  )}
                </div>

                {/* {detail.Langkah?.length > 0 && (
                  <>
                    <hr />
                    <h6 className="text-muted">Tahap Pengerjaan</h6>
                    <ul className="list-unstyled mb-0">
                      {detail.Langkah.map((l) => (
                        <li key={l.id} className="mb-2">
                          <span className="badge bg-light text-dark me-2">{l.urutan}</span>
                          {l.tahap} — <em>{l.status}</em>
                          {l.foto && (
                            <div className="mt-1">
                              <SecureFileImg
                                src={`${process.env.REACT_APP_URL}/files/images/${l.foto}`}
                                alt="foto langkah"
                                style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd' }}
                              />
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </>
                )} */}

                {rabData && (
                  <>
                    <hr />
                    <h6 className="text-muted">RAB (Rencana Anggaran Biaya)</h6>
                    <div className="row mb-2">
                      <div className="col-6"><small className="text-muted">Keterangan</small><br /><strong>{rabData.keterangan || '-'}</strong></div>
                      <div className="col-6"><small className="text-muted">Total Harga</small><br /><strong>{formatRp(rabData.totalHarga)}</strong></div>
                    </div>
                    {rabData.SupplierToko?.length > 0 && (
                      <div className="mb-2">
                        <small className="text-muted">Toko Supplier ({rabData.SupplierToko.length})</small>
                        <div className="d-flex flex-wrap gap-1 mt-1">
                          {rabData.SupplierToko.map(st => (
                            <span key={st.id} className="badge bg-light text-dark">{st.SupplierBarang?.namaToko || `Toko #${st.SupplierBarangId}`}</span>
                          ))}
                        </div>
                      </div>
                    )}
                    {rabData.fileRab && (
                      <Button size="sm" color="primary" outline onClick={() => openInAppFilePreview({ url: `${process.env.REACT_APP_URL}/rab/file/${rabData.fileRab.replace('rab/', '')}` })}>
                        <Visibility fontSize="small" sx={{ mr: 0.5 }} /> Lihat Berkas RAB
                      </Button>
                    )}

                    <Box sx={{ mt: 2 }}>
                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography variant="body2" fontWeight={600}><Receipt fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />A. Progress Administrasi</Typography>
                          <Chip size="small" sx={{ ml: 1 }} label={`${progressAdministrasi.filter(l => l.status === 'Selesai').length}/${progressAdministrasi.length}`} variant="outlined" />
                        </AccordionSummary>
                        <AccordionDetails>
                          {progressAdministrasi.length > 0 ? (
                            <TimelineList items={progressAdministrasi} basePath="rab-progress-administrasi" onPreview={openPreview} />
                          ) : <small className="text-muted">Belum ada data.</small>}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography variant="body2" fontWeight={600}><Receipt fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />B. Progress Keuangan</Typography>
                          <Chip size="small" sx={{ ml: 1 }} label={`${progressKeuangan.filter(l => l.status === 'Selesai').length}/${progressKeuangan.length}`} variant="outlined" />
                        </AccordionSummary>
                        <AccordionDetails>
                          {progressKeuangan.length > 0 ? (
                            <TimelineList items={progressKeuangan} basePath="rab-progress" isSingleFoto onPreview={openPreview} type="keuangan" />
                          ) : <small className="text-muted">Belum ada data.</small>}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography variant="body2" fontWeight={600}><Engineering fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />C/D. Progress Fisik</Typography>
                          <Chip size="small" sx={{ ml: 1 }} label={`${progressFisik.filter(l => l.status === 'Selesai').length}/${progressFisik.length}`} variant="outlined" />
                        </AccordionSummary>
                        <AccordionDetails>
                          {progressFisik.length > 0 ? (
                            <Box>
                              <Chip size="small" label={`Tipe: ${progressFisik[0]?.tipe || '-'}`} color="primary" sx={{ mb: 1 }} />
                              <TimelineList items={progressFisik} basePath="rab-progress-fisik" onPreview={openPreview} type="fisik" />
                            </Box>
                          ) : <small className="text-muted">Belum ada data.</small>}
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </>
                )}
              </div>
            ) : (
              <Alert color="warning">Data tidak ditemukan.</Alert>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setDetailOpen(false)}>
              Tutup
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Form Tambah/Edit Bantuan */}
        <Modal
          isOpen={formOpen}
          toggle={() => setFormOpen(false)}
          size="xl"
          centered
          className="databantuan-modal"
          modalClassName="databantuan-modal-overlay"
          contentClassName="databantuan-modal-content"
          style={{ maxWidth: isMobile ? '100%' : '960px', width: isMobile ? '100%' : 'auto' }}
          zIndex={2000}
        >
          <ModalHeader toggle={() => setFormOpen(false)} style={{ padding: isMobile ? '0.75rem' : undefined }}>
            {formMode === 'add' ? 'Tambah Bantuan' : 'Edit Bantuan'}
          </ModalHeader>
          <ModalBody style={{ maxHeight: isMobile ? '80vh' : '75vh', overflowY: 'auto', padding: isMobile ? '0.75rem' : undefined }}>
            {/* =============== PERBAIKAN: Tampilkan Tab untuk Admin & TFL =============== */}
            {formMode === 'add' && canAccessCRUD && (
              <div className="mb-3 d-flex gap-2">
                <Button 
                  color={formTab === 'integrasi' ? 'primary' : 'outline-primary'} 
                  size="sm"
                  onClick={() => setFormTab('integrasi')}
                >
                  Tambah Data Penerima Bantuan
                </Button>
                {/* <Button 
                  color={formTab === 'manual' ? 'success' : 'outline-success'} 
                  size="sm"
                  onClick={() => setFormTab('manual')}
                >
                  Bantuan SK Manual (TFL)
                </Button> */}
              </div>
            )}
            <Form>
              {formMode === 'add' && formTab === 'manual' ? (
                <ManualBantuanFields form={form} setForm={setForm} tflList={tflList} agrList={agrList} supplierList={supplierList} isTfl={isTfl} />
              ) : (
                <>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-semibold">Jenis Bantuan</Label>
                        <Input
                          type="select"
                          value={form.JenisBantuan}
                          onChange={(e) => setForm((p) => ({ ...p, JenisBantuan: e.target.value }))}
                        >
                          {JENIS_DISPLAY.map((j) => {
                            const backendVal = DISPLAY_TO_BACKEND[j];
                            return <option key={j} value={backendVal}>{j}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-semibold">Nominal (Rp)</Label>
                        <Input
                          type="text"
                          inputMode="numeric"
                          placeholder="Contoh: 6.000.000"
                          value={formatNominalInput(form.nominal)}
                          onChange={(e) => setForm((p) => ({
                            ...p,
                            nominal: parseNominalInput(e.target.value)
                          }))}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">Nominal Material (Rp)</Label>
                        <Input type="text" inputMode="numeric" placeholder="0"
                          value={formatNominalInput(form.nominalMaterial)}
                          onChange={(e) => setForm((p) => ({ ...p, nominalMaterial: parseNominalInput(e.target.value) }))} />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">Nominal Upah Kerja (Rp)</Label>
                        <Input type="text" inputMode="numeric" placeholder="0"
                          value={formatNominalInput(form.nominalUpahKerja)}
                          onChange={(e) => setForm((p) => ({ ...p, nominalUpahKerja: parseNominalInput(e.target.value) }))} />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">Total Material + Upah (Rp)</Label>
                        <Input type="text" readOnly
                          value={formatNominalInput((Number(form.nominalMaterial) || 0) + (Number(form.nominalUpahKerja) || 0))}
                          style={{ backgroundColor: '#f5f5f5', fontWeight: 600 }} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">TFL Pendamping</Label>
                        <Input
                          type="select"
                          value={form.AdminId || ''}
                          disabled={isTfl}
                          onChange={(e) => setForm((p) => ({ ...p, AdminId: e.target.value }))}
                        >
                          {!isTfl && <option value="">(Pilih TFL)</option>}
                          {tflList.map((t) => (
                            <option key={t.id} value={t.id}>{t.username} — {t.NoWa || '-'}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">AGR Pendamping</Label>
                        <Row className="g-1 mb-1">
                          <Col xs={6}>
                            <Input type="select" bsSize="sm" value={form.agrFilterKecamatan || ''}
                              onChange={(e) => setForm((p) => ({
                                ...p,
                                agrFilterKecamatan: e.target.value,
                                agrFilterDesa: '',
                              }))}>
                              <option value="">Semua Kecamatan</option>
                              {KECAMATAN.map((k) => <option key={k} value={k}>{k}</option>)}
                            </Input>
                          </Col>
                          <Col xs={6}>
                            <Input type="select" bsSize="sm" value={form.agrFilterDesa || ''}
                              disabled={!form.agrFilterKecamatan}
                              onChange={(e) => setForm((p) => ({
                                ...p,
                                agrFilterDesa: e.target.value,
                              }))}>
                              <option value="">{form.agrFilterKecamatan ? 'Semua Desa/Kel.' : 'Pilih kecamatan dulu'}</option>
                              {getDesaByKecamatan(form.agrFilterKecamatan).map((d) => (
                                <option key={d} value={d}>{d}</option>
                              ))}
                            </Input>
                          </Col>
                        </Row>
                        <Input
                          type="select"
                          value={form.AgrId || ''}
                          onChange={(e) => setForm((p) => ({ ...p, AgrId: e.target.value }))}
                        >
                          <option value="">(Pilih AGR)</option>
                          {filteredAgrList.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.username} — {a.NoWa || '-'}{a.desaKelurahan ? ` (${a.desaKelurahan})` : ''}
                            </option>
                          ))}
                        </Input>
                        {(form.agrFilterKecamatan || form.agrFilterDesa) && (
                          <small className="text-muted">
                            Menampilkan {filteredAgrList.length} AGR
                            {form.agrFilterDesa ? ` di Desa/Kel. ${form.agrFilterDesa}` : form.agrFilterKecamatan ? ` di Kec. ${form.agrFilterKecamatan}` : ''}
                          </small>
                        )}
                      </FormGroup>
                    </Col>
                     <Col md={4}>
  <FormGroup>
    <Label className="fw-semibold">Toko Supplier (bisa pilih lebih dari 1)</Label>
    <div style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 6, padding: '4px 8px' }}>
      {supplierList.map((s) => {
        const isChecked = (form.supplierIds || []).includes(s.id);
        return (
          <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '3px 0' }}>
            <input
              type="checkbox"
              id={`sup_${s.id}`}
              checked={isChecked}
              onChange={(e) => {
                setForm((p) => ({
                  ...p,
                  supplierIds: e.target.checked
                    ? [...(p.supplierIds || []), s.id]
                    : (p.supplierIds || []).filter(id => id !== s.id),
                  supplierId: e.target.checked && !p.supplierId ? s.id : p.supplierId,
                }));
              }}
              style={{ margin: 0 }}
            />
            <label htmlFor={`sup_${s.id}`} style={{ fontSize: 13, cursor: 'pointer', margin: 0 }}>
              {s.namaToko || s.namaSupplier || `Toko #${s.id}`}
            </label>
          </div>
        );
      })}
      {supplierList.length === 0 && (
        <small className="text-muted">Belum ada toko tersedia</small>
      )}
    </div>
  </FormGroup>
</Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label className="fw-semibold">No. WA Penerima</Label>
                            <Input
                              placeholder="Contoh: 081234567890"
                              value={form.noWaPenerimaBantuan || ''}
                              onChange={(e) => setForm((p) => ({ ...p, noWaPenerimaBantuan: e.target.value }))}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label className="fw-semibold">No. Rekening</Label>
                            <Input
                              placeholder="Contoh: 1234567890"
                              value={form.noRekening || ''}
                              onChange={(e) => setForm((p) => ({ ...p, noRekening: e.target.value }))}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-semibold">Tanggal Bantuan</Label>
                        <Input
                          type="date"
                          value={form.tanggalBantuan}
                          onChange={(e) => setForm((p) => ({ ...p, tanggalBantuan: e.target.value }))}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-semibold">Sumber Data Penerima Bantuan</Label>
                        <Input
                          type="select"
                          value={form.sumberType}
                          onChange={(e) => setForm((p) => ({
                            ...p,
                            sumberType: e.target.value,
                            selQuestionnaire: null,
                            selRegisterUsulan: null,
                            selVerifikasi: null,
                            sumberPreview: null,
                            desil: '',
                            kode: '',
                            HasilVerfak: ''
                          }))}
                        >
                          <option value="">(Tanpa sumber)</option>
                          <option value="Questionnaire">Questionnaire</option>
                          <option value="Verifikasi">Validasi</option>
                          <option value="RegisterUsulan">Register Usulan</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">Desil</Label>
                        <Input
                          type="text"
                          value={form.desil}
                          onChange={(e) => setForm((p) => ({ ...p, desil: e.target.value }))}
                          placeholder="Otomatis dari skor sumber data"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">Kode</Label>
                        <Input
                          type="text"
                          value={form.kode}
                          onChange={(e) => setForm((p) => ({ ...p, kode: e.target.value }))}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-semibold">Hasil Verfak</Label>
                        <Input
                          type="text"
                          value={form.HasilVerfak}
                          onChange={(e) => setForm((p) => ({ ...p, HasilVerfak: e.target.value }))}
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}
                

                  {form.sumberType === 'Questionnaire' && (
                    <FormGroup>
                      <Label>Pilih Questionnaire (cari & scroll)</Label>
                      <SourceDropdown
                        type="questionnaire"
                        value={form.selQuestionnaire}
                        onChange={(val) => {
                          setForm((p) => ({ ...p, selQuestionnaire: val, QuestionnaireId: val?.id || '' }));
                          applySourceSelection('Questionnaire', val);
                        }}
                      />
                    </FormGroup>
                  )}

                  {form.sumberType === 'Verifikasi' && (
                    <FormGroup>
                      <Label>Pilih Validasi (cari & scroll)</Label>
                      <SourceDropdown
                        type="verifikasi"
                        value={form.selVerifikasi}
                        onChange={(val) => {
                          setForm((p) => ({ ...p, selVerifikasi: val, VerifikasiId: val?.id || '' }));
                          applySourceSelection('Verifikasi', val);
                        }}
                      />
                    </FormGroup>
                  )}

                  {form.sumberType === 'RegisterUsulan' && (
                    <FormGroup>
                      <Label>Pilih Register Usulan (cari & scroll)</Label>
                      <SourceDropdown
                        type="registerUsulan"
                        value={form.selRegisterUsulan}
                        onChange={(val) => {
                          setForm((p) => ({ ...p, selRegisterUsulan: val, RegisterUsulanId: val?.id || '' }));
                          applySourceSelection('RegisterUsulan', val);
                        }}
                      />
                    </FormGroup>
                  )}

                  {form.sumberPreview && (
                    <div className="border rounded p-3 mb-3 bg-light">
                      <h6 className="text-muted mb-2">Data Diri Terpilih</h6>
                      <div className="row">
                        <DetailRow label="Nama" value={form.sumberPreview.nama || form.sumberPreview.namaLengkapKK || form.sumberPreview.namaKepalaKeluarga} />
                        <DetailRow label="NIK" value={form.sumberPreview.nik || form.sumberPreview.nomorKTP} />
                        <DetailRow label="Alamat" value={form.sumberPreview.alamat || form.sumberPreview.alamatRumah} />
                        <DetailRow label="Kecamatan" value={form.sumberPreview.kecamatan} />
                        <DetailRow label="Desa/Kelurahan" value={form.sumberPreview.desaKelurahan} />
                        <DetailRow label="Nomor KK" value={form.sumberPreview.nomorKK} />
                        <DetailRow label="Kategori / Status" value={form.sumberPreview.kategori || form.sumberPreview.statusVerifikasi || form.sumberPreview.status} />
                        <DetailRow label="Skor" value={form.sumberPreview.score} />
                      </div>
                      {form.sumberPreview.fotos && form.sumberPreview.fotos.length > 0 && (
                        <div className="mt-2">
                          <small className="text-muted d-block mb-1">Foto Rumah</small>
                          <div className="d-flex gap-1 flex-wrap">
                            {form.sumberPreview.fotos.slice(0, 5).map((f, fi) => (
                              <img key={fi} src={`${process.env.REACT_APP_URL}/${f.foto_rumah}`} alt={`Foto ${fi+1}`}
                                style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd', cursor: 'pointer' }}
                                onClick={() => openInAppFilePreview({ url: `${process.env.REACT_APP_URL}/${f.foto_rumah}` })} />
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </Form>
          </ModalBody>
          <ModalFooter style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 8 : 0 }}>
            <Button color="secondary" onClick={() => setFormOpen(false)} block={isMobile}>Batal</Button>
            <Button color="success" disabled={saving} onClick={handleSave} block={isMobile}>
              {saving ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Penunjukan TFL */}
        <Modal isOpen={assignOpen} toggle={() => setAssignOpen(false)} style={{ maxWidth: isMobile ? '100%' : '500px', width: isMobile ? '100%' : 'auto', margin: isMobile ? '0' : undefined, zIndex: 2100 }}>
          <ModalHeader toggle={() => setAssignOpen(false)} style={{ padding: isMobile ? '0.75rem' : undefined }}>Penunjukan TFL & Toko</ModalHeader>
          <ModalBody style={{ padding: isMobile ? '0.75rem' : undefined }}>
            <p className="text-muted mb-2">
              Penerima: <strong>{assignRow?.pemohon?.nama || assignRow?.namaLengkap || '-'}</strong>
            </p>
            <FormGroup>
              <Label>TFL Pendamping</Label>
              <Input type="select" value={assignForm.AdminId}
                disabled={isTfl}
                onChange={(e) => setAssignForm((p) => ({ ...p, AdminId: e.target.value }))}>
                {!isTfl && <option value="">Pilih TFL</option>}
                {tflList.map((t) => (
                  <option key={t.id} value={t.id}>{t.username} — {t.NoWa || '-'}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>AGR Pendamping</Label>
              <Input type="select" value={assignForm.AgrId}
                onChange={(e) => setAssignForm((p) => ({ ...p, AgrId: e.target.value }))}>
                <option value="">(Pilih AGR)</option>
                {agrList.map((a) => (
                  <option key={a.id} value={a.id}>{a.username} — {a.NoWa || '-'}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>Toko Supplier (bisa pilih Lebih dari 1)</Label>
              <div style={{ maxHeight: 160, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 6, padding: '4px 8px' }}>
                {supplierList.map((s) => {
                  const isChecked = (assignForm.supplierIds || []).includes(s.id);
                  return (
                    <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '3px 0' }}>
                      <input
                        type="checkbox"
                        id={`asup_${s.id}`}
                        checked={isChecked}
                        onChange={(e) => {
                          setAssignForm((p) => ({
                            ...p,
                            supplierIds: e.target.checked
                              ? [...(p.supplierIds || []), s.id]
                              : (p.supplierIds || []).filter(id => id !== s.id),
                            supplierId: e.target.checked && !p.supplierId ? s.id : p.supplierId,
                          }));
                        }}
                        style={{ margin: 0 }}
                      />
                      <label htmlFor={`asup_${s.id}`} style={{ fontSize: 13, cursor: 'pointer', margin: 0 }}>
                        {s.namaToko || s.namaSupplier || `Toko #${s.id}`}
                      </label>
                    </div>
                  );
                })}
                {supplierList.length === 0 && (
                  <small className="text-muted">Belum ada toko tersedia</small>
                )}
              </div>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setAssignOpen(false)}>Batal</Button>
            <Button color="primary" onClick={handleAssignTfl}>Simpan Penunjukan</Button>
          </ModalFooter>
        </Modal>

      

        {/* File Preview Modal */}
        <FilePreviewModal
          open={preview.open}
          onClose={() => setPreview((p) => ({ ...p, open: false }))}
          files={preview.files}
          labels={preview.labels}
          fileBase={preview.fileBase}
          title={preview.title}
        />

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          TransitionComponent={Fade}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert 
            onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
            severity={snackbar.severity} 
            variant="filled" 
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default DataBantuan;
